document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".mega-menu .mega-menu__linklist > li");

  items.forEach(async (li) => {
    const a = li.querySelector("a");
    if (!a) return;

    // handle from URL safely
    const path = new URL(a.href, window.location.origin).pathname; 
    const match = path.match(/\/collections\/([^\/]+)/);
    if (!match) return;

    const handle = match[1].toLowerCase().trim();

    let img = "";

    try {
      // 1) collection image
      const colRes = await fetch(`/collections/${handle}.json`);
      const colData = await colRes.json();
      img = colData?.collection?.image?.src || "";

      // 2) fallback: first product image (collection.json often doesn't include products)
      if (!img) {
        const prodRes = await fetch(`/collections/${handle}/products.json?limit=1`);
        const prodData = await prodRes.json();
        img = prodData?.products?.[0]?.images?.[0]?.src || "";
      }
    } catch (e) {
      console.log("Mega menu image fetch error:", handle, e);
      return;
    }

    if (!img) return;

   li.innerHTML = `
  <a href="${a.href}" style="display: flex; flex-direction: column; align-items: center; gap: 8px; text-decoration: none; text-align: center; padding: 10px; transition: background 0.3s;">
    <img src="${img}" alt="${a.textContent.trim()}"
         style="width: 100px; height: 100px; object-fit: cover; margin-bottom: 5px;">
    <span class="h6" style="margin: 0; color: inherit;">${a.textContent.trim()}</span>
  </a>
`;
  });
});



// ---- add to cart buy now -----

document.addEventListener("DOMContentLoaded", function () {
  var btn = document.querySelector('.sticky-box button[type="submit"]');
  if (btn) {
    btn.textContent = "Buy Now";
  }
});


document.addEventListener("DOMContentLoaded", function() {

  function removeTrailingZeros() {
    document.querySelectorAll("sale-price, compare-at-price, .price, .money").forEach(function(el) {
      
      let text = el.innerHTML.trim();

      // Replace only .00 at end
      text = text.replace(/\.00(?!\d)/g, '');

      el.innerHTML = text;
    });
  }

  removeTrailingZeros();

  // If theme updates price dynamically (variant change)
  document.addEventListener("variant:change", function() {
    setTimeout(removeTrailingZeros, 100);
  });

});


// ------


// products order sync -------
(function () {

  function run() {

    const list = document.querySelector('.product-list');

    if (!list) {
      console.log('❌ .product-list not found');
      return;
    }

    const path = window.location.pathname.toLowerCase();

    const configMap = {

      '/collections/handbags': [
        { keys: ["tote", "totes"], displayPriority: 1 },
        { keys: ["luma mini tote", "luma"], displayPriority: 2 },
        { keys: ["sling"], displayPriority: 3 },
        { keys: ["carry all", "carryall"], displayPriority: 4 }
      ],

      '/collections/laptop-bags-sleeves': [
        {
          keys: ["laptop/ipad sleeve with handle"],
          displayPriority: 2
        },
        {
          keys: ["laptop/ipad sleeve"],
          displayPriority: 1
        },
        {
          keys: ["laptop bag"],
          displayPriority: 3
        }
      ],

      '/collections/backpacks': [
        {
          keys: ["mini backpack", "mini back pack"],
          displayPriority: 1
        }
      ]

    };

    const matchedKey = Object.keys(configMap).find(key =>
      path.includes(key)
    );

    if (!matchedKey) {
      console.log('❌ Collection config not found:', path);
      return;
    }

    console.log('✅ Collection matched:', matchedKey);

    function normalize(str) {
      return String(str || '')
        .toLowerCase()
        .trim()
        .replace(/[\s\-_\/]+/g, '');
    }

    function reorder() {

      const groups = configMap[matchedKey];

      const cards = Array.from(
        list.querySelectorAll('product-card')
      );

      console.log('Products found:', cards.length);

      if (!cards.length) return;

      const classified = cards.map((card, index) => {

        const titleEl = card.querySelector(
          '.product-title'
        );

        if (!titleEl) {

          console.log('❌ Product title not found in card');

          return {
            card,
            priority: 999,
            originalIndex: index
          };
        }

        const originalTitle = titleEl.textContent.trim();
        const title = normalize(originalTitle);

        let priority = 999;

        groups.forEach(group => {

          group.keys.forEach(groupKey => {

            const key = normalize(groupKey);

            if (title.includes(key)) {
              priority = Math.min(
                priority,
                group.displayPriority
              );
            }

          });

        });

        console.log(
          originalTitle,
          '=>',
          title,
          '=> Priority:',
          priority
        );

        return {
          card,
          priority,
          originalIndex: index
        };

      });

      classified.sort((a, b) => {

        if (a.priority !== b.priority) {
          return a.priority - b.priority;
        }

        return a.originalIndex - b.originalIndex;

      });

      const fragment = document.createDocumentFragment();

      classified.forEach(item => {
        fragment.appendChild(item.card);
      });

      list.appendChild(fragment);

      console.log(
        '✅ Final Order:',
        classified.map(item =>
          item.card.querySelector('.product-title')
            ?.textContent.trim()
        )
      );

    }

    reorder();

    setTimeout(reorder, 500);
    setTimeout(reorder, 1500);
    setTimeout(reorder, 3000);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
// --- produt- hide----

